import React from 'react';

const KPI_GROUPS = [
  {
    key: 'general',
    label: 'General',
    accentColor: '#3b82f6',
    kpiTypes: ['MSS_IMAGE_LOAD_START', 'MSS_OUT_OF_RESET', 'MODEM_IN_SERVICE'],
  },
  {
    key: 'wwan',
    label: 'WWAN Connectivity',
    accentColor: '#0d9488',
    kpiTypes: ['WWAN_V4_ASSIGNMENT', 'WWAN_V6_ASSIGNMENT'],
  },
  {
    key: 'fronthaul',
    label: 'FrontHaul',
    accentColor: '#f97316',
    kpiTypes: ['WLAN_V4_ASSIGNMENT', 'LAN_V4_ASSIGNMENT', 'WLAN_V6_ASSIGNMENT', 'LAN_V6_ASSIGNMENT'],
  },
];

const ALL_PREDEFINED = KPI_GROUPS.flatMap(g => g.kpiTypes);

const formatNumber = (value) => {
  if (typeof value !== 'number' || isNaN(value)) return '0';
  return value.toFixed(2);
};

const formatCount = (value) => {
  if (typeof value !== 'number' || isNaN(value)) return '0';
  return Math.round(value).toLocaleString();
};

const KpiGroupTable = ({ label, accentColor, kpiTypes, timingHistograms }) => (
  <div className="boot-kpi-table-container">
    <div className="boot-kpi-group-header">
      <span className="boot-kpi-group-dot" style={{ backgroundColor: accentColor }} />
      <h4>{label}</h4>
    </div>
    <div className="boot-kpi-table-wrapper">
      <table className="boot-kpi-table">
        <thead>
          <tr>
            <th className="boot-kpi-table-header-kpi">KPI Type</th>
            <th className="boot-kpi-table-header">Count</th>
            <th className="boot-kpi-table-header">Mean (secs)</th>
            <th className="boot-kpi-table-header">Min (secs)</th>
            <th className="boot-kpi-table-header">Max (secs)</th>
            <th className="boot-kpi-table-header">Std Dev (secs)</th>
          </tr>
        </thead>
        <tbody>
          {kpiTypes.map((kpiType, index) => {
            const data = timingHistograms[kpiType] || {};
            return (
              <tr key={kpiType} className={index % 2 === 0 ? 'boot-kpi-table-row-even' : 'boot-kpi-table-row-odd'}>
                <td className="boot-kpi-table-cell-kpi">{kpiType}</td>
                <td className="boot-kpi-table-cell">{formatCount(data.count)}</td>
                <td className="boot-kpi-table-cell">{formatNumber(data.mean)}</td>
                <td className="boot-kpi-table-cell">{formatNumber(data.min)}</td>
                <td className="boot-kpi-table-cell">{formatNumber(data.max)}</td>
                <td className="boot-kpi-table-cell">{formatNumber(data.stdDev)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  </div>
);

const BootKpiTable = ({ timingHistograms }) => {
  if (!timingHistograms || typeof timingHistograms !== 'object') {
    return (
      <div className="boot-kpi-table-container">
        <div className="boot-kpi-table-empty">
          <p>No Boot KPI timing data available</p>
        </div>
      </div>
    );
  }

  const additionalKpiTypes = Object.keys(timingHistograms)
    .filter(kpi => !ALL_PREDEFINED.includes(kpi))
    .sort();

  return (
    <div>
      {KPI_GROUPS.map(group => (
        <KpiGroupTable
          key={group.key}
          label={group.label}
          accentColor={group.accentColor}
          kpiTypes={group.kpiTypes}
          timingHistograms={timingHistograms}
        />
      ))}
      {additionalKpiTypes.length > 0 && (
        <KpiGroupTable
          key="other"
          label="Other"
          accentColor="#6b7280"
          kpiTypes={additionalKpiTypes}
          timingHistograms={timingHistograms}
        />
      )}
    </div>
  );
};

export default BootKpiTable;
